import { Box, Container } from "@mui/material";
import HeroSection from "../components/HeroSection";
import FeaturedRecipe from "../components/FeaturedRecipe";
import VideosSection from "../components/VideosSection";
import Products from "./Products";

export default function Home() {
  return (
    <Container sx={{ backgroundColor: "white", p: 1, mt: 1 }}>
      <HeroSection />
      <FeaturedRecipe />
      <VideosSection />
      <Products />
    </Container>
  );
}
